(function(){
  if (window.__g26Run) { window.__g26Run(); return; }
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  function io(cb, opts){ return 'IntersectionObserver' in window ? new IntersectionObserver(cb, opts||{rootMargin:'0px 0px -8% 0px'}) : null; }

  function reveal(){
    var els=document.querySelectorAll('.g26 [data-g26-reveal]:not(.is-in)');
    var o=io(function(en){ en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); o.unobserve(x.target);} }); });
    els.forEach(function(e){ o ? o.observe(e) : e.classList.add('is-in'); });
  }
  function countUp(){
    document.querySelectorAll('.g26-stats__card b, .g26-out__item b').forEach(function(el){
      if(el.dataset.g26c) return; el.dataset.g26c=1;
      var m=el.textContent.trim().match(/^([^\d]*)([\d.,]+)(.*)$/); if(!m||RM||/^\//.test(m[3])) return;
      var pre=m[1], raw=m[2].replace(/,/g,''), post=m[3], to=parseFloat(raw), dec=(raw.split('.')[1]||'').length;
      if(isNaN(to)) return; el.textContent=pre+(0).toFixed(dec)+post;
      var o=io(function(en){ en.forEach(function(x){ if(!x.isIntersecting) return; o.unobserve(el);
        var t0=performance.now(), d=1600;
        (function f(t){ var p=Math.min(1,(t-t0)/d), e=1-Math.pow(1-p,3); el.textContent=pre+(to*e).toFixed(dec)+post; if(p<1) requestAnimationFrame(f); })(t0);
      }); },{threshold:.4});
      o ? o.observe(el) : (el.textContent=m[0]);
    });
  }
  function tilt(){
    if(RM||!FINE) return;
    document.querySelectorAll('.g26-pc__card, .g26-feat__item, .g26-stats__card, .g26-out__item, .g26-roles__card, .g26-ind__tile, .g26-tm__card').forEach(function(c){
      if(c.dataset.g26t) return; c.dataset.g26t=1; c.setAttribute('data-g26-tilt','');
      c.addEventListener('mousemove',function(e){ var r=c.getBoundingClientRect(), x=(e.clientX-r.left)/r.width, y=(e.clientY-r.top)/r.height;
        c.classList.add('is-tilting'); c.style.transform='perspective(800px) rotateX('+((.5-y)*8).toFixed(2)+'deg) rotateY('+((x-.5)*10).toFixed(2)+'deg) translateY(-4px)';
        c.style.setProperty('--mx',(x*100)+'%'); c.style.setProperty('--my',(y*100)+'%'); });
      c.addEventListener('mouseleave',function(){ c.classList.remove('is-tilting'); c.style.transform=''; });
    });
    document.querySelectorAll('.g26__card').forEach(function(c){ if(c.dataset.g26g) return; c.dataset.g26g=1;
      c.addEventListener('mousemove',function(e){ var r=c.getBoundingClientRect(); c.style.setProperty('--mx',(e.clientX-r.left)+'px'); c.style.setProperty('--my',(e.clientY-r.top)+'px'); }); });
  }
  function spot(){
    if(!FINE) return;
    document.querySelectorAll('[id^="g26-band-"],[id^="g26-proc-"],[id^="g26-stats-"],[id^="g26-ref-"]').forEach(function(s){
      if(s.dataset.g26s) return; s.dataset.g26s=1;
      s.addEventListener('mousemove',function(e){ var r=s.getBoundingClientRect(); s.style.setProperty('--mx',(e.clientX-r.left)+'px'); s.style.setProperty('--my',(e.clientY-r.top)+'px'); });
    });
  }
  function parallax(){
    if(RM||!FINE) return;
    var map=[['.g26-hero__fc',22],['.g26-hero__mascot',8],['.g26-hero__glow',-12],['.g26-hero__ring',6],['.g26-hero__spark',28],['.g26-ph__device',16],['.g26-ph__mascot',8],['.g26-ph__pill',24],['.g26-ph__blob',-10],['.g26-ph__spark',30]];
    map.forEach(function(p){ document.querySelectorAll(p[0]).forEach(function(el){ el.setAttribute('data-g26-par',''); el.style.setProperty('--depth',p[1]+'px'); }); });
    document.querySelectorAll('[id^="g26-hero-"],[id^="g26-ph-"]').forEach(function(s){
      if(s.dataset.g26p) return; s.dataset.g26p=1;
      s.addEventListener('mousemove',function(e){ var r=s.getBoundingClientRect(); s.style.setProperty('--px',((e.clientX-r.left)/r.width-.5).toFixed(3)); s.style.setProperty('--py',((e.clientY-r.top)/r.height-.5).toFixed(3)); });
      s.addEventListener('mouseleave',function(){ s.style.setProperty('--px',0); s.style.setProperty('--py',0); });
    });
  }
  function orbs(){
    var cols=[['#B9C8FF','#FFE3A3'],['#C9F0DE','#D8CCFF'],['#FFE3A3','#BFD0FF']];
    document.querySelectorAll('[id^="g26-feat-"],[id^="g26-out-"],[id^="g26-roles-"],[id^="g26-demo-"],[id^="g26-cm-"],[id^="g26-ind-"],[id^="g26-pc-"]').forEach(function(s,i){
      if(s.dataset.g26o) return; s.dataset.g26o=1;
      s.style.position='relative'; s.style.overflow='hidden';
      var w=s.querySelector('.g26__wrap'); if(w){ w.style.position='relative'; w.style.zIndex=1; }
      var c=cols[i%3];
      [[c[0],'-120px','auto','auto','-80px',360,0],[c[1],'auto','-100px','-60px','auto',300,-6]].forEach(function(o){
        var d=document.createElement('span'); d.className='g26-orb'; d.setAttribute('aria-hidden','true');
        d.style.cssText='background:'+o[0]+';top:'+o[1]+';right:'+o[2]+';bottom:'+o[3]+';left:'+o[4]+';width:'+o[5]+'px;height:'+o[5]+'px;animation-delay:'+o[6]+'s;';
        s.insertBefore(d,s.firstChild);
      });
    });
  }
  function timeline(){
    document.querySelectorAll('.g26-proc__steps').forEach(function(t){ if(t.dataset.g26l) return; t.dataset.g26l=1;
      var o=io(function(en){ en.forEach(function(x){ if(x.isIntersecting){ t.style.setProperty('--g26-line',1); o.unobserve(t);} }); },{threshold:.3});
      o ? o.observe(t) : t.style.setProperty('--g26-line',1); });
  }
  function progress(){
    if(RM||document.querySelector('.g26-progress')) return;
    var b=document.createElement('div'); b.className='g26-progress'; document.body.appendChild(b);
    var tick=false; function u(){ var h=document.documentElement, m=h.scrollHeight-h.clientHeight; b.style.transform='scaleX('+(m>0?h.scrollTop/m:0)+')'; tick=false; }
    window.addEventListener('scroll',function(){ if(!tick){ tick=true; requestAnimationFrame(u);} },{passive:true}); u();
  }
  function run(){ reveal(); countUp(); tilt(); spot(); parallax(); orbs(); timeline(); progress(); }
  window.__g26Run=run;
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
  document.addEventListener('shopify:section:load',run);
})();
